import { CIDService } from "./../../../../services/common/cid.service";
import { Component, OnInit, Inject } from "@angular/core";

import { IGroup } from "src/app/interfaces/group";
import { SoundEnum } from "src/app/enums/sound.enum";
import { ICompany } from "src/app/interfaces/company";
import { TranslateService } from "@ngstack/translate";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ErrorsService } from "src/app/services/common/errors.service";
import { SnackBarService } from "./../../../../services/common/snackBar.service";
import { GroupService } from "src/app/services/http/business/group/group.service";
import { CompanyEntryComponent } from "../../company/company-entry/company-entry.component";
import { CompanyService } from "src/app/services/http/business/company/company.service";
import { HoldingService } from "src/app/services/http/business/holding/holding.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-group-entry",
  templateUrl: "./group-entry.component.html",
  styleUrls: ["./group-entry.component.css"],
  providers: [ErrorsService]
})
export class GroupEntryComponent implements OnInit {
  param: any;
  errorList: IError[] = [];
  errObject: any;
  form: FormGroup;
  isOwner: boolean;
  cCode: string;
  errors = new Array();
  companyList: ICompany[];

  constructor(
    private fb: FormBuilder,
    private cidService: CIDService,
    private snackBar: SnackBarService,
    private groupService: GroupService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private holdingService: HoldingService,
    private companyService: CompanyService,
    private dialogRef: MatDialogRef<CompanyEntryComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IGroup
  ) {}

  ngOnInit() {
    this.getCompanyList();
    this.cCode = this.cidService.getCID();
    this.holdingService.checkOwnerHolding().subscribe(res => {
      this.isOwner = res.IsOwner;
      if (res.IsOwner) {
        this.getCompanyList();
      }
    });
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      companyCode: [
        this.cidService.getCID(),
        Validators.compose([Validators.required])
      ],
      Title: [
        this.data && this.data.Title ? this.data.Title : null,
        Validators.compose([Validators.required, Validators.maxLength(70)])
      ],
      Code: [
        this.data && this.data.Code ? this.data.Code : "",
        Validators.compose([Validators.maxLength(30)])
      ]
    });
  }

  getCompanyList() {
    this.companyService.list(0, 0).subscribe(res => {
      this.companyList = res.DataList;
    });
  }

  onNoClick() {
    this.dialogRef.close();
  }

  setCompanyCode(e: string) {
    this.cidService.setCID(e);
  }

  submit(form: IGroup) {
    this.errors = new Array();
    if (this.data == null) {
      this.groupService.add(form).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("label.submit"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.onNoClick();
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error);
        }
      );
    }
    if (this.data && this.data.Title) {
      form.Id = this.data.Id;
      this.groupService.edit(form).subscribe(
        () => {
          this.snackBar.OpenSnackBar(
            this.translate.get("label.submit"),
            "ok",
            5000,
            SoundEnum.beep
          );
          this.dialogRef.close(form);
        },
        error => {
          // this.errObject = this.errorService.getError(error);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(error);
          this.errorList = this.errorService.getErrorList(error.error);
        }
      );
    }
  }
}
